module.exports = __webpack_public_path__ + "static/media/play.5bd0adaf.svg";